import React from "react";

function AnalyticsData() {
  return <div className="comming-soon">Comming Soon...</div>;
}

export default AnalyticsData;
